import { Trans } from 'react-i18next';

import { Link } from '@dreryk/react-components';
import { resolveDeclensionTranslationKey, useTranslate } from '@dreryk/react-common';

import { sharedTranslationKeys } from '../../../translations';

const t = sharedTranslationKeys.attachmentsLinks;

type RemovedLinkViewProps = Readonly<{
   removedAttachmentsCount: number;
   onShowMoreAttachments: VoidFunction;
}>;

export const RemovedLinkView = (props: RemovedLinkViewProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <Link
         testId='showMoreRemovedAttachments'
         block={false}
         onClick={props.onShowMoreAttachments}
         label={
            <Trans
               i18nKey={t.restAttachments}
               values={{
                  count: props.removedAttachmentsCount,
                  declensionForm: translate(
                     resolveDeclensionTranslationKey(
                        props.removedAttachmentsCount,
                        t.moreRemovedAttachmentsCount.nominative,
                        t.moreRemovedAttachmentsCount.accusative,
                        t.moreRemovedAttachmentsCount.genitive
                     )
                  ),
               }}
            />
         }
      />
   );
};
